import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { KeyboardTimePicker } from "mui-rff";

import { styles } from "./TimePicker.styles";

function TimePicker({ classes, id, label, required, placeholder }) {
  return (
    <div className={classes.root}>
      <KeyboardTimePicker
        label={label}
        name={id}
        required={required}
        autoOk
        disableToolbar
        ampm={false}
        variant="inline"
        format="HH:mm"
      />
    </div>
  );
}

export default withStyles(styles)(TimePicker);
